export default __webpack_public_path__ + "images/stripe-payment-element/jcb-521c559c59f49ed03d0e34c42bef85da.svg";